import { CashAccountModel } from 'api-hooks/cash-account';
import React from 'react';

import { CashAccountFormType } from '../components/form-type';

export default function useCashAccountDefaultValues(
  cashAccount?: CashAccountModel,
): CashAccountFormType {
  const defaultValues = React.useMemo<CashAccountFormType>(() => {
    return {
      balance: cashAccount?.balance || 0,
      code: cashAccount?.code || '',
      description: cashAccount?.description || '',
      name: cashAccount?.name || '',
      cashAccount,
    };
  }, [cashAccount]);

  return defaultValues;
}
